<template>
  <div class="findcolor-container">
    <!-- 게임 상단 : 타이머, 스테이지 -->
    <div class="findcolor_header">
      <div class="findcolor_timer">
        <div class="findcolor_time_text">
          TIME
        </div>
        <div class="findcolor_time_number">
          <Timer
            ref="timer"
            type="countdown"
            auto-start
            :length="10 * 1000"
            @done="onDone"
            v-slot="{ time, isOverflowed }"
          >
            <div>
              <span
                :class="{ 'is-overflowed': isOverflowed }"
                style="width: 100%; display:flex; justify-content: left;"
              >
                <div style="width: 40%;">
                  <span>{{ time.s }}</span>
                </div>
                <div style="width: 5%;"><span> : </span></div>
                <div style="width: 40%;">
                  <span>{{ time.ms.substring(0, 2) }}</span>
                </div>
              </span>
            </div>
          </Timer>
        </div>
      </div>
      <div class="findcolor_stage">
        <div class="findcolor_stage_text">
          STAGE
        </div>
        <div class="findcolor_stage_number">
          {{ score }}
        </div>
      </div>
      <div class="findcolor_newgame" v-on:click="() => reGame()">
        <font-awesome-icon icon="redo" style="font-size: 1rem;" />
      </div>
    </div>
    <!-- 게임 화면 -->
    <div class="findcolor_game">
      <!-- 준비 -->
      <div
        v-show="gameMode === 'ready'"
        v-on:click="() => gamePlay()"
        class="findcolor_ready"
        :style="{
          background: makeColor(h, s, l, 1),
          color: makeColor(h, s, l, 0)
        }"
      >
        <font-awesome-icon
          icon="stopwatch"
          style="font-size: 3rem; margin-bottom: 10px;"
        />
        touch to start
      </div>
      <!-- 종료 -->
      <div
        v-show="gameMode === 'gameover'"
        class="findcolor_share"
        :style="{ background: makeColor(h, s, l, 1) }"
      >
        <!-- 캡쳐 -->
        <div
          class="findcolor_capture"
          ref="findcolor_capture"
          :style="{
            background: makeColor(h, s, l, 1)
          }"
        >
          your stage
          <br />
          <div class="findcolor_share_record">
            {{ score }}
          </div>
        </div>
        <div class="findcolor_share_text">
          share it with your friends
        </div>
        <share
          url="https://spready.net/find-color"
          title="다른 색깔 찾기"
          :image="image"
        />
      </div>
      <!-- 게임 화면 -->
      <div v-show="gameMode === 'play'">
        <table class="findcolor_matrix">
          <tr v-for="(rowData, rowIndex) in grid" :key="rowIndex">
            <td
              class="findcolor_td"
              :style="{
                background: gridcolor(rowIndex, cellIndex),
                width: getsize(),
                height: getsize()
              }"
              v-for="(cellData, cellIndex) in rowData"
              :key="cellIndex"
              @click="onClickGrid(rowIndex, cellIndex)"
            />
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import random from "lodash.random";
import { TimerVue as Timer } from "@josephuspaye/timer";
import Share from "./Share";

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "findColor",
  components: {
    Timer,
    Share
  },
  data() {
    return {
      level: 2,
      score: 1,
      h: "",
      s: "",
      l: "",
      gameMode: "",
      grid: [],
      image: null
    };
  },
  created() {
    this.score = 1;
    this.level = 2;
    this.generategrid();
    this.makeColor();
  },
  mounted() {
    this.gameMode = "ready";
  },
  methods: {
    generategrid() {
      /* 배열 초기화 하고, 격자 전체를 1 로 채우기 */
      this.grid = [];
      for (let i = 0; i < this.level; i++) {
        this.grid[i] = [];
        for (let j = 0; j < this.level; j++) {
          this.grid[i].push(1);
        }
      }
      /* 하나만 랜덤하게 0 으로 채우기 */
      this.grid[random(0, this.level - 1)][random(0, this.level - 1)] = 0;
      this.h = random(0, 360);
      this.s = random(10, 95);
      this.l = random(20, 95);
    },
    /* 격자가 1 이면 같은 색을 0 이면 다른 색을 칠함 */
    gridcolor(ridx, cidx) {
      for (let i = 0; i < this.level; i++) {
        for (let j = 0; j < this.level; j++) {
          if (this.grid[ridx][cidx] == 1) {
            return this.makeColor(this.h, this.s, this.l, 1);
          } else {
            return this.makeColor(this.h, this.s, this.l, 0);
          }
        }
      }
    },
    /* 격자 하나의 크기는 level 의 크기로 정함 */
    getsize() {
      return 360 / this.level + "px";
    },
    /* 4번 맞출 때마다 격자 증가, 10칸이상은 증가 안시킴 */
    getLevel() {
      if (this.level <= 9 && this.score % 4 == 0) {
        this.level++;
      }
    },
    makeColor(h, s, l, val) {
      if (val == 0) {
        l = l - 50 / (0.3 * this.score + 1);
      }
      return "hsl(" + h + ", " + s + "%, " + l + "%)";
    },
    /* 클릭해서 0 을 찾으면 다음 스테이지로 이동 */
    onClickGrid(ridx, cidx) {
      if (this.grid[ridx][cidx] == 0) {
        this.score++;
        this.getLevel();
        this.generategrid();
        this.$refs.timer.reset();
        this.$refs.timer.toggle();
      }
    },
    gamePlay() {
      this.gameMode = "play";
    },
    /* 타이머 다 돌면 게임 종료 */
    onDone() {
      this.gameMode = "gameover";
    },
    reGame() {
      this.gameMode = "ready";
    },
    async capture() {
      const findcolorscoreScreen = this.$refs.findcolor_capture;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(findcolorscoreScreen, options);
      const file = dataURLtoFile(image, "findcolorscoreScreen.png");
      this.image = file;
    }
  },
  watch: {
    gameMode: {
      async handler(value) {
        if (value === "gameover") {
          await this.capture();
        } else if (value === "ready") {
          this.$refs.timer.reset();
          this.score = 1;
          this.level = 2;
          this.generategrid();
          this.makeColor();
        } else if (value === "play") {
          this.$refs.timer.reset();
          this.$refs.timer.toggle();
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@500&display=swap");

.findcolor-container {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: top;
  align-items: center;
  text-align: center;
  flex-direction: column;
  font-family: "Rubik", sans-serif;
}
.findcolor_header {
  width: 360px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: row;
}
.findcolor_timer {
  width: 46%;
  height: 100%;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: row;
}
.findcolor_stage {
  width: 40%;
  display: flex;
}
.findcolor_newgame {
  width: 14%;
  height: 70%;
  background: #ffffff;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #c8c8c8;
  cursor: pointer;
}
.findcolor_time_text {
  width: 50%;
  color: #999999;
}
.findcolor_time_number {
  width: 50%;
}
.findcolor_stage_text {
  width: 50%;
  color: #999999;
}
.findcolor_stage_number {
  width: 30%;
}
.findcolor_game {
  width: 360px;
  height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 10px;
}
.findcolor_share {
  width: 100%;
  height: 100%;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.findcolor_ready {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  font-size: 1rem;
  cursor: pointer;
}
.findcolor_matrix {
  width: 100%;
  height: 100%;
}
.findcolor_capture {
  padding: 50px 70px 30px 70px;
  color: #ffffff;
  text-shadow: 0px 0px 1px black;
  display: flex;
  font-size: 1rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.findcolor_share_record {
  font-size: 3rem;
}
.findcolor_share_text {
  margin-bottom: 10px;
  font-size: 1rem;
  color: white;
  text-shadow: 0px 0px 1px black;
}
</style>
